import React, {Component} from 'react'
import FrameShape from "../types/FrameShape";
import { LINE_CAP_CONSTS, LINE_JOIN_CONSTS } from 'shape-edit/forms/helpers';
import { SizeType } from 'app/types/model-types';

interface Props {
    data: FrameShape
    size: SizeType
}

class FrameSvg extends Component<Props> {
    render() {
        const frame = this.props.data
        const size = this.props.size

        const lineJoin = frame.line_join && LINE_JOIN_CONSTS[frame.line_join] ? LINE_JOIN_CONSTS[frame.line_join]: 'inherit'
        const strokeLinecap=frame.line_cap && LINE_CAP_CONSTS[frame.line_cap] ? LINE_CAP_CONSTS[frame.line_cap]: 'inherit'

        return (
            <g transform={`translate(${parseFloat(`${frame.margin_x}`) + (frame.width / 2)},${parseFloat(`${frame.margin_y}`) + (frame.width / 2)})`}>
                <rect 
                    width={size.width - (2 * frame.margin_x) - frame.width}
                    height={size.height - (2 * frame.margin_y) - frame.width}
                    stroke={frame.color} fill="transparent" 
                    strokeWidth={frame.width}
                    strokeLinecap={strokeLinecap} 
                    strokeLinejoin={lineJoin}  
                />
            </g>
        )
    }
}

export default FrameSvg
